// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__259b5","tab":"Tabs_tab__2Gh-f","tabActive":"Tabs_tabActive__2opbd"};